module.exports = __webpack_public_path__ + "pc/img/career-developer.97ff52d0.png";